import { Card } from 'react-bootstrap'
import { GroupSelect } from 'GroupSelect'
import { useSettings } from 'Settings'

const type_options = [
	{ value: "MAX", label : "MAX" },
	{ value: "TYP", label : "TYP" },
	{ value: "MIN", label : "MIN" },
]

const ColdStartAccuracy = (props) => {
	const [settings] = useSettings()
	const csa = settings['cold-start accuracy']

	return (
		<Card className="mb-3">
			<Card.Header>Cold-Start Accuracy</Card.Header>
			<Card.Body>
				<GroupSelect
					options={type_options}
					defaultValue={type_options[1]}
					name="v_cs_acc"
					value={csa['v_cs_acc'].value}
					onChange={(v) => csa['v_cs_acc'].setValue(v.value)}
				/>
			</Card.Body>
		</Card>
	)
}

export default ColdStartAccuracy
